import React, { useState } from 'react';
import SettingsPage from '../pages/SettingsPage';

const AdminSettings = ({ settings, userPermissions, onSave }) => {
  const [activeTab, setActiveTab] = useState('general');

  return (
    <div className="row">
      <div className="col">
        <div className="card border-0 shadow-sm">
          <div className="card-body">
            <SettingsPage settings={settings} userPermissions={userPermissions} onSave={onSave} activeTab={activeTab} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSettings;